<template>
  <v-card height="800">
    ggggh
    <iframe
      :src="iframe.src"
      :style="iframe.style"
      :height="iframe.height"
      :width="iframe.width"
      type="application/pdf"
      frameborder="0"
    />
  </v-card>
</template>

<script>
  export default {
    name: 'Iframe',
    data: () => ({
      iframe: {
        src: 'http://abr.abrap.ir/ov/entrepot/productlist?masteroff=yes&http_hostapi=abr.abrap.ir',
        style: null,
        height: 400,
        width: '100%',
      },
      load: false,
    }),
    mounted () {
      this.load = true
    },
  }
</script>

<style scoped>

</style>
